<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:acao-cancelar="fecharModal"
			:is-confirmar-desabilitado="!formIsValid || erroObrigatoriedade"
			@close="fecharModal"
		>
			<template #body>
				<novo-anexo-generico :infoAnexo="infoAnexo" :tipo-documento="tipoDocumento"></novo-anexo-generico>
			</template>
		</modal>
	</v-form>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/core/constants'
import NovoAnexoGenerico from '@/views/components/documentos/controle-documentos/modal-adicionar/anexos/novo-anexo/NovoAnexoGenerico.vue'

export default {
	name: 'modal-adicionar-anexos-generico',
	components: { NovoAnexoGenerico },
	props: {
		idEntidade: {
			type: Number,
			required: true,
		},
		exibir: {
			type: Boolean,
			required: true,
		},
		tipoDocumento: {
			type: Object,
			required: true,
		},
		idPastaExternaDigital: {
			type: String,
			required: true,
		},
		repositorioFlowbee: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			formIsValid: false,
			infoAnexo: null,
		}
	},
	computed: {
		...mapState({
			arquivoTemporario: (state) => state.campoArquivoNovo.arquivoTemporario,
			erroObrigatoriedade: (state) => state.campoArquivoNovo.erroObrigatoriedade,
		}),
		titulo() {
			if (this.documento) {
				return 'Editar Anexo'
			}

			return 'Adicionar Anexo'
		},
	},
	mounted() {
		this.infoAnexo = {
			id: this.idEntidade,
			idPastaExternaDigital: this.idPastaExternaDigital,
			repositorioFlowbee: this.repositorioFlowbee,
		}
	},
	methods: {
		async salvarAnexos() {
			if (this.arquivoTemporario) {
				await this.$store.dispatch(actionTypes.DOCUMENTOS.ANEXO.INSERIR_GENERICO, {
					anexo: this.montarDocumento(this.$store.state.campoArquivoNovo.documentoComAnexo),
					tipo: this.tipoDocumento,
				})

				this.mostrarNotificacaoSucessoDefault()
				this.fecharModal()
				this.$store.commit(mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_DOCUMENTO_COM_ANEXOS)
			}
		},
		montarDocumento(anexo) {
			return {
				titulo: anexo.titulo,
				idTipoDocumento: anexo.idTipoDocumento,
				idExternoAnexoTemporario: anexo.idExternoAnexoTemporario,
				idEntidade: this.idEntidade,
			}
		},
		async confirmar() {
			this.$store.commit(
				mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ERRO_OBRIGATORIEDADE_ARQUIVO,
				!this.arquivoTemporario,
			)

			if (this.$refs.form.validate() && !this.erroObrigatoriedade) {
				await this.salvarAnexos()
				this.fecharModal()
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
